// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gld_","newExpiryDate":"styles_newExpiryDate__35e-I","footer":"styles_footer__RwWhD"};